import React, { FC } from 'react'

import { Loader2Icon } from 'lucide-react'

import { getRankColor } from '../../../../helpers/rank'

interface RankNumberProps {
  rank: number | null
  loading?: boolean
  onClick?: () => void
}
export const RankNumber: FC<RankNumberProps> = ({ rank, onClick, loading }) => {
  return (
    <button
      type="button"
      disabled={loading}
      onClick={onClick}
      data-rank={Number(rank)}
      className="rounded-full text-base flex items-center justify-center w-10 h-10 hover:opacity-70 transition-all text-white"
      style={{ background: getRankColor(Number(rank)) }}
    >
      {loading ? <Loader2Icon className="animate-spin w-4" /> : rank}
    </button>
  )
}
